export default __webpack_public_path__ + "static/media/FlexOs.57f613fb.svg";